import styled from "styled-components";

export const DatePickerContainer = styled.div`
    display: flex;
    flex-direction: column;
`;